import { Vector3 } from "@babylonjs/core";
import React from "react";
import { Mesh } from "react-babylonjs";
import SimpleWallSectionSolid from "./SimpleWallSectionSolid";

const LeftAwningSolid = ({ leftAwning, length, offset, lengthArray, gap }) => {
    let theta = Math.atan2(leftAwning.length, leftAwning.roofPitch);
    let hypotenouse = leftAwning.length / Math.sin(theta)
    let l = leftAwning.length;
    let p = Math.sqrt( hypotenouse*hypotenouse - l*l)/2

    if (leftAwning.visible)
        return <Mesh name="leftAwning_solid_1" position={new Vector3(-length/2, 0 , offset/2-leftAwning.length)}>
            <SimpleWallSectionSolid
                lengthArray={lengthArray}
                position={new Vector3(0, leftAwning.height/4, 0)}
                height={leftAwning.height}
                gap={gap}
            ></SimpleWallSectionSolid>
                <Mesh name="skillion_right_solid_1" position={new Vector3(0, p + leftAwning.height, leftAwning.length/2)}>
                    <SimpleWallSectionSolid
                        lengthArray={[length]}
                        height={hypotenouse}
                        rotation={new Vector3(theta, 0, 0)}
                        gap={gap}
                    ></SimpleWallSectionSolid>
                </Mesh>
        </Mesh>
    else return <React.Fragment></React.Fragment>;
}

export default LeftAwningSolid